import { Component, OnInit } from "@angular/core";


import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';
import { StoreHelper } from '../shared/helpers/store.helper';

@Component({
    selector: 'app-preview-training',
    templateUrl: './preview-training.component.html',
    styleUrls: ['./preview-training.component.scss'],
    standalone: false
})
export class PreviewTrainingComponent implements OnInit {
  dataSource: any;

  trainings = [];

  notifications = [];

  library = [];

  showTip = true;

  columnNames = [
    {
      id: "code",
      value: "Code",
    },
    {
      id: "name",
      value: "Name",
    },
  ];
  displayedColumns = [];

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private router: Router,
    public controller: ControllerService,
  ) {}

  async previewLibrary(code) {
    this.controller.flushLibrary();

    await this.fetchLibrary(code);

    this.controller.setPreviewing(true);

    await this.controller.fetchContents(this.library);

    this.controller.setupLibrary(false, code);
    this.controller.goToLibrary();
  }

  hideTip() {
    StoreHelper.setObject("hidePreviewTip", true);
    this.showTip = false;
  }

  showNotification(tipId) {
    return !StoreHelper.getObject(`hidePreviewTip-${tipId}`);
  }

  hideNotification(tipId) {
    StoreHelper.setObject(`hidePreviewTip-${tipId}`, true);
  }

  downloadUserGuide(code) {
    const url = this.controller.getUserGuideURL(code);
    window.open(url, "_blank");
  }

  async doTraining(id, code) {
    const training = this.trainings.find(
      ({ hcontent_id }) => id === hcontent_id,
    );

    const { step, complete } = training;

    if (complete) {
      // already did this training, do not allow redo.
      return;
    }

    const result: any = await this.httpService.postAsync("user/ensureCode", {
      code,
    });
    if (!result.success) {
      alert(
        "An error occurred loading the training. Please contact your Rare Success Manager for assistance.",
      );
      return;
    }

    this.controller.flushLibrary();

    await this.fetchLibrary(code);

    this.controller.loadHemisphere(id, false, false);
    this.controller.setupLibrary(false);
    this.controller.shiftContainerToMiddle();

    this.controller.setActivationCode(code);
    this.controller.resume(step ? step : 0);
  }

  async previewTraining(id, code) {
    this.controller.flushLibrary();

    await this.fetchLibrary(code);

    const training = this.trainings.find(
      ({ hcontent_id }) => id === hcontent_id,
    );
    const { complete } = training;
    if (!complete) {
      if (
        !confirm(
          "You have not completed this training. Previewing will not record your progress nor it will count toward the training completion. Do you wish to continue?",
        )
      ) {
        return;
      }
    }

    this.controller.loadHemisphere(id, true, false);
    this.controller.setupLibrary(false);
    this.controller.setActivationCode(code);
    this.controller.resume(0);
  }

  async fetchLibrary(code) {
    const resp: any = await this.httpService.postAsync(
      "user/getLibraryForCode",
      { code },
    );
    if (resp.success) {
      this.library = resp.data;
    } else {
      alert(resp.message);
    }
  }

  loading = false
  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(3).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchTrainings(){
    this.loading = true
    this.generateSkeletonRows()

    // Clear data to show skeleton
    this.dataSource.data = []

    try{
      // Wait for both the API call and at least 1 second
      const [resp]: [any, any] = await Promise.all([
        this.httpService.getAsync('user/getHRTrainings'),
        new Promise(resolve => setTimeout(resolve, 500))
      ]);

      if( resp.success ){
        this.trainings = resp.data
        this.notifications = resp.notifications
        await this.controller.fetchContents(this.trainings)
        this.dataSource.data = this.trainings
      }else{
        alert( resp.message )
      }
    }catch(e){
      console.error(e)
    } finally {
      this.loading = false
    }

  }

  copySmartURL(code) {
    const domain =
      window.location.hostname.indexOf("beta") > -1 ? "beta" : "learn";
    const url = `https://${domain}.hemisphereapp.io/start?activationCode=${code}`;
    navigator["clipboard"].writeText(url);
  }

  async ngOnInit() {
    this.displayedColumns = this.columnNames
      .map((x) => x.id)
      .concat([
        "userGuide",
        "copySmartURL",
        "doTraining",
        "preview",
        "previewLibrary",
      ]);
    this.dataSource = new MatTableDataSource(this.trainings);

    this.showTip = StoreHelper.getObject("hidePreviewTip") ? false : true;

    await this.fetchTrainings();
  }
}
